'use client'

import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import { forwardRef } from 'react'
import './pig-spinner.scss'

const classes = generateClassNames('pig-spinner', ['icon'])

export interface PigSpinnerProps
  extends React.HTMLAttributes<HTMLSpanElement> {}

const PigSpinner = forwardRef<HTMLSpanElement, PigSpinnerProps>(
  function PigSpinner(props, ref) {
    const { className, ...other } = props

    return (
      <span
        ref={ref}
        className={clsx(classes.root, className)}
        role='progressbar'
        {...other}
      >
        <div className={classes.icon} />
      </span>
    )
  }
)

export default PigSpinner
